import { ComponentExtensionRegistry } from '~/plugins/ComponentExtensionRegistry';
import OutputToReportCheckbox from './components/OutputToReportCheckbox';
import { ReportOutputLabel } from './components/ReportOutputLabel';

export const initPlugin = (): void => {
  ComponentExtensionRegistry.register('workHistory.modal.extras', {
    id: 'control-report-history-output',
    component: OutputToReportCheckbox,
    order: 100,
    featureFlag: 'ControlReportHistoryOutput',
  });

  ComponentExtensionRegistry.register('workHistory.item.extras', {
    id: 'control-report-history-output.label',
    component: ReportOutputLabel,
    order: 100,
    featureFlag: 'ControlReportHistoryOutput',
  });
};

// Parent-child relationship resolved from config/tenants/default.json via API.
// ClientPluginLoader uses this to determine initialization order.
export const parentPlugin = 'MonthlyReportCustomization';

export const resources_ja: Record<string, string> = {
  'function.ControlReportHistoryOutput': '案件報告書出力制御',
  'reportOutput.label': '報告書出力',
  'reportOutput.yes': 'する',
  'reportOutput.no': 'しない',
};
